import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { 
  IoHomeOutline, 
  IoSettingsOutline, 
  IoPeopleOutline, 
  IoPersonOutline,
  IoStatsChartOutline,
  IoNotificationsOutline,
  IoTrophyOutline,
  IoFlagOutline,
  IoBookOutline,
  IoLogOutOutline,
  IoMenuOutline,
  IoCloseOutline,
  IoChevronBackOutline
} from 'react-icons/io5';
import './AdminLayout.css';

const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const adminNavItems = [
    { id: 'dashboard', label: 'Dashboard', icon: IoStatsChartOutline, path: '/admin/dashboard' },
    { id: 'families', label: 'Family Groups', icon: IoPeopleOutline, path: '/admin/families' },
    { id: 'users', label: 'User Management', icon: IoPersonOutline, path: '/admin/users' },
    { id: 'challenges', label: 'Challenges', icon: IoFlagOutline, path: '/admin/challenges' },
    { id: 'goals', label: 'Site Goals', icon: IoTrophyOutline, path: '/admin/goals' },
    { id: 'reports', label: 'Reading Reports', icon: IoBookOutline, path: '/admin/reports' },
    { id: 'notifications', label: 'Notifications', icon: IoNotificationsOutline, path: '/admin/notifications' },
    { id: 'settings', label: 'Admin Settings', icon: IoSettingsOutline, path: '/admin/settings' },
  ];

  const handleNavigation = (path) => {
    navigate(path);
    setSidebarOpen(false);
  };

  const handleBackToMain = () => {
    navigate('/');
  };

  const handleLogout = async () => {
    await logout();
    setSidebarOpen(false);
  };

  const currentPath = location.pathname;
  const currentNavItem = adminNavItems.find(item => item.path === currentPath);

  return (
    <div className="admin-layout">
      {/* Admin Header */}
      <header className="admin-header">
        <div className="admin-header-left">
          <button 
            className="mobile-menu-button"
            onClick={() => setSidebarOpen(true)}
          >
            <IoMenuOutline />
          </button>
          <button 
            className="back-to-main-button"
            onClick={handleBackToMain}
            title="Back to Main Site"
          >
            <IoChevronBackOutline />
            <span>Back to Site</span>
          </button>
          <div className="admin-title">
            <h1>Admin Panel</h1>
            {currentNavItem && (
              <span className="current-page">{currentNavItem.label}</span>
            )}
          </div>
        </div>
        <div className="admin-header-right">
          <div className="admin-user-info">
            <span className="admin-user-name">{user?.name}</span>
            <span className="admin-badge">Admin</span>
          </div>
          <button 
            className="logout-button"
            onClick={handleLogout}
            title="Logout"
          >
            <IoLogOutOutline />
          </button>
        </div>
      </header>

      <div className="admin-content-wrapper">
        {/* Admin Sidebar */}
        <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
          <div className="admin-sidebar-header">
            <h2>Admin Menu</h2>
            <button 
              className="close-sidebar-button"
              onClick={() => setSidebarOpen(false)}
            >
              <IoCloseOutline />
            </button>
          </div>
          
          <nav className="admin-nav">
            {adminNavItems.map((item) => {
              const Icon = item.icon;
              const isActive = currentPath === item.path;
              
              return (
                <button
                  key={item.id}
                  className={`admin-nav-item ${isActive ? 'active' : ''}`}
                  onClick={() => handleNavigation(item.path)}
                >
                  <Icon className="nav-icon" />
                  <span className="nav-label">{item.label}</span>
                </button>
              );
            })}
          </nav>

          <div className="admin-sidebar-footer">
            <button 
              className="back-to-main-sidebar"
              onClick={handleBackToMain}
            >
              <IoHomeOutline />
              <span>Back to Main Site</span>
            </button>
          </div>
        </aside>

        {/* Admin Main Content */}
        <main className="admin-main">
          {children}
        </main>
      </div>

      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div 
          className="admin-sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
};

export default AdminLayout;
